import { Link } from 'react-router-dom';
import Searchbar from './Searchbar';
import ThemeToggle from '../toggle/ThemeToggle';
import LangToggle from '../toggle/LangToggle';

export default function Header({ text }) {
  return (
    <header className="fixed top-0 left-0 w-full z-50 flex items-center justify-center">
      <div className="text-sm pr-4 sm:pr-0 py-4 text-text-light overflow-hidden flex items-center justify-between lg:w-[60em] md:w-[40em] sm:w-[50em] w-[100%]">
        <div className="text-gray text-xl px-4">
          <Link to="/" title="Homepage link">
            <i className="bx bx-home-alt-2" />
          </Link>
        </div>
        <Searchbar
          text={text}
          linkType="external"
          link="https://docs.google.com/document/d/1bA7MqkkFcwjIvi3_2M1OOFlAP6PnjR7VvHQ2q5T541M"
          type={'header'}
        />
        <LangToggle />
        <ThemeToggle />
      </div>
    </header>
  );
}
